import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Typography,
  useMediaQuery,
  useScrollTrigger,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React from "react";
import logo from '../Pages/Main/logo.png';
import { Motion } from "./Motion";
import { theme } from "../Resources/Design/theme";
import { ADMIN_HEIGHT } from "../Routes/AdminPanel";
import { pastelDark } from "../Pages/Main/constants";
import NavbarDrawer from "./NavbarDrawer";
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import Face4RoundedIcon from '@mui/icons-material/Face4Rounded';
import CollectionsRoundedIcon from '@mui/icons-material/CollectionsRounded';
import GradeRoundedIcon from '@mui/icons-material/GradeRounded';

export const NAVBAR_HEIGHT = 100;

export const navigation = [
  { path: "/", name: "Tábory", id: "", icon: EventNoteRoundedIcon },
  { path: "/kurzy", name: "Kurzy", id: "course", icon: EventNoteRoundedIcon },
  //{ path: "/", name: "Programy", id: "programy", icon: EventNoteRoundedIcon },
  { path: "/about", name: "Kdo jsme", id: '', icon: Face4RoundedIcon },
  { path: "/fotky", name: "Fotky", id: '', icon: CollectionsRoundedIcon },
  { path: "/reference", name: "Reference", id: '', icon: GradeRoundedIcon },
];

const navColor = 'transparent';//#fafafa
const navColorElevated = 'rgba(255,255,255,0.8)';//'rgba(255,214,186,0.92)';

const shadow = 0.3;

function Navbar({ bgcolor = navColorElevated, xsText = {}, isAdmin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [hovered, setHovered] = React.useState(null);
  const currentPath = location.pathname;
  const elevated = useScrollTrigger({ disableHysteresis: true });
  const height = `auto`;// ${NAVBAR_HEIGHT}px
  const mobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <header>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          elevation={0}
          position={"fixed"}
          sx={{
            top: isAdmin ? `${ADMIN_HEIGHT}px` : 0,
            maxHeight: height,
            height: height,
            backgroundColor: elevated ? bgcolor : navColor,
            ".MuiToolbar-root": {
              minHeight: height,
              maxHeight: height,
              height: height,
              px: "16px",
              maxWidth: 1200,
              width: "100%",
              mx: "auto",
              zIndex: 10,
            },
          }}
        >
          <Toolbar>
            <Motion scale={1.03}>
              <Box
                component={Link}
                sx={{
                  marginRight: "auto",
                  display: "flex",
                  alignItems: "center",
                  alignContent: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                  pl: "0px",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                to={"/"}
                aria-label='Hlavní stránka'
              >
                <Box component={'img'} alt='logo hello kids camp' src={logo} sx={{
                  width: elevated ? (mobile ? '80px' : '100px') : (mobile ? '120px' : '160px'),
                  transition: "width .3s ease-in-out",
                  py: '0px', filter: `
      drop-shadow(0px 0px 1px rgba(0,0,0,0.3))
    `,
                }} />
              </Box>
            </Motion>
            <Box
              sx={{
                marginLeft: "auto",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                {Boolean(mobile) && <NavbarDrawer />}
                {Boolean(!mobile) && <>{navigation.map((data, index) => (
                  <Button
                    key={"ButtonNavbar" + index}
                    id={"ButtonNavbarId" + index}
                    name={`ButtonNavbarN${index}`}
                    sx={{
                      mr: "8px",
                      backgroundColor: "transparent",
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                    component={Link}
                    to={data.path}
                    tabIndex={index}
                    onClick={(e) => {
                      e.preventDefault();
                      let timeout = 0;
                      if (data?.path !== currentPath) {
                        if (e.target.name === hovered) {
                          setHovered(null);
                        }
                        timeout = 200;
                        navigate(data.path);
                      }
                      if (data?.id) {
                        setTimeout(() => {
                          const el = document.getElementById(data.id);
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth", block: 'start' });
                          }
                        }, timeout);
                      }
                    }}
                    onMouseEnter={(e) => {
                      setHovered(e.target.name);
                    }}
                    onMouseLeave={(e) => {
                      if (e.target.name == hovered) {
                        setHovered(null);
                      }
                    }}
                    onContextMenu={(e) => {
                      setHovered(null);
                    }}
                    aria-label={`${data.name}`}
                  >
                    <Typography
                      variant="navbar"
                      sx={{
                        transform:
                          hovered == `ButtonNavbarN${index}`
                            ? "translateY(-2px)"
                            : "translateY(0px)",
                        transitionDuration: "200ms",
                        fontWeight: 700,
                        fontSize: '16px',
                        textTransform: 'uppercase',
                        color: elevated ? pastelDark : "#fff",
                        textShadow: elevated ? 'none' : `
      1px 1px 1px rgba(0,0,0,${shadow}),
      -1px -1px 1px rgba(0,0,0,${shadow}),
      1px -1px 1px rgba(0,0,0,${shadow}),
      -1px 1px 1px rgba(0,0,0,${shadow})
    `,
                        ...xsText,
                      }}
                    >
                      {data.name}
                    </Typography>
                  </Button>
                ))}</>}
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    </header>
  );
}

export default Navbar;

